import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetGroupsQuery } from '../redux/apis/usersManagement/users/uMUsersApiSlice'

const GroupDropdown = ({ onChange, onBlur, value, className = '',mode="" }) => {
  const { data, isLoading, error } = useGetGroupsQuery({
     page: '*',
     fields: 'id,name',
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Groups</label>
      <br />
      <Select
        name='groups'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.name, value: x.id }
        })}
        mode={mode}
      />
    </div>
  )
}

export default GroupDropdown
